var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var NombreFabricanteProducto = function (_a) {
    var nombre = _a.nombre;
    return React.createElement(NombreFabricante, null, nombre);
};
var NombreFabricante = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 10px;\n  font-weight: bold;\n  text-transform: uppercase;\n  margin-top: 5px;\n  padding-bottom: 5px;\n  color: gray;\n"], ["\n  font-size: 10px;\n  font-weight: bold;\n  text-transform: uppercase;\n  margin-top: 5px;\n  padding-bottom: 5px;\n  color: gray;\n"])));
export default NombreFabricanteProducto;
var templateObject_1;
